import React, { Fragment, useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import Switch from "react-switch";
import _ from "lodash";
import { api, constants, dateHelpers } from "../utils";
import { DesktopContainer } from "../layouts";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { ColPrompt } from "./SpecEditComponents"
import { ColValue } from "./ProductionModule"

export default function ShippingLookup(props) {
   const [orderNumber, setOrderNumber] = useState("");
   const [printers, setPrinters] = useState([]);
   const [printPDF, setPrintPDF] = useState(false);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [shipmentList, setShipmentList] = useState(null);
   const [voidPassword, setVoidPassword] = useState("");

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      getPrinters();
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   function formatPrinters(data) {
      let printerArr = _.concat(data.labels, data.lasers, data.parts);
      let list = _.map(printerArr, (x) => {
         return { label: x.nameOnly, value: x.id };
      });
      return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response) {
               setPrinters(formatPrinters(response.data));
            } else {
               toast.error("Failed to get printers.");
            }
         })
         .catch(api.catchHandler);
   }

   function getShipment() {
      api.fetch(`Shipment/GetShipmentsByOrderNumber/${orderNumber}`)
         .then(response => {
            if (response && response.data && response.data.success) {
               if (response.data.message) {
                  setShipmentList(response.data.message);
                  // setShipmentConfirm(response.data.message?.parsedShipmentConfirmRequest?.shipment);
               }
            }
            else {
               toast.error(response?.data?.message || "Error finding shipment");
            }
         })
         .catch(api.catchHandler);
   }

   function printShippingActivity(packageInfo, activity, name, amount, trackingNumber, upsShipmentId, idx) {
      return (<div key={`pkgIdx-${idx}`}>
         <Card className="dashboard-card">
            <CardBody>
               <Row>
                  <ColValue>
                     <Row><Col>Ship To</Col></Row>
                     {packageInfo?.createdAt
                        ? <Row><Col>Created: {packageInfo?.createdAt}</Col></Row>
                        : null}
                  </ColValue>
                  <ColValue>
                     <Row><Col>Company:</Col><Col>{name}</Col></Row>
                     <Row>
                        <Col>Address:</Col>
                        <Col>
                           {packageInfo?.attentionName
                              ? <Row><Col>{packageInfo?.attentionName}</Col></Row>
                              : null}
                           {packageInfo?.addressLine1
                              ? <Row><Col>{packageInfo?.addressLine1}</Col></Row>
                              : null}
                           {packageInfo?.addressLine2
                              ? <Row><Col>{packageInfo?.addressLine2}</Col></Row>
                              : null}
                           {packageInfo?.addressLine3
                              ? <Row><Col>{packageInfo?.addressLine3}</Col></Row>
                              : null}
                           {packageInfo?.city || packageInfo?.state
                              ? <Row><Col>{packageInfo?.city}, {packageInfo?.state} {packageInfo?.postalCode}</Col></Row>
                              : null}
                        </Col>
                     </Row>
                     <Row><Col>Phone:</Col><Col>{packageInfo?.phone}</Col></Row>
                     <Row><Col>Fax:</Col><Col>{packageInfo?.faxNumber}</Col></Row>
                  </ColValue>
               </Row>
               <Row>
                  <ColValue>Status</ColValue>
                  <ColValue>
                     <Row>
                        <ColValue>
                           {activity?.statusDescription
                              ? <Row><Col>{activity?.statusDescription}</Col></Row>
                              : null}
                        </ColValue>
                     </Row>
                  </ColValue>
               </Row>
               <Row>
                  <ColValue>Shipping Charges</ColValue>
                  <ColValue>
                     <Row>
                        <ColValue>
                           {amount
                              ? amount
                              : null}
                        </ColValue>
                     </Row>
                  </ColValue>
               </Row>
               {trackingNumber
                  ? (<Row>
                     <ColValue>Tracking Numbers</ColValue>
                     <ColValue>
                        {trackingNumber}
                     </ColValue>
                     <ColValue>
                        <Button className="shredButton" style={{ margin: "5px" }} onClick={() => { reprintLabels(trackingNumber, upsShipmentId) }} >Reprint Label</Button>
                     </ColValue>
                  </Row>)
                  : null}
            </CardBody>
         </Card>
      </div>);
   }

   function reprintLabels(trackingNumber, upsShipmentId) {
      if (!printPDF && !selectedPrinter) {
         toast.warning("Please select a printer")
         return;
      }
      let payload = {
         // OrderNumber: orderNumber,
         PrintPDF: printPDF,
         UPSShipmentId: upsShipmentId,
         TrackingNumber: trackingNumber,
         PrinterId: printPDF ? 0 : selectedPrinter.value,
         PrinterName: printPDF ? "" : selectedPrinter.label
      };
      if (payload.PrintPDF) {
         api
            .postDownloadBinary(
               `Shipment/ReprintUPSLabel`,
               payload,
               constants.MIME_TYPES.pdf,
               `PrintedUPSLabels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the labels, contact your admin."
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               } else {
                  toast.success("Labels Printed");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
            });
      }
      else {
         api.post("Shipment/ReprintUPSLabel", payload)
            .then(response => {
               if (response.data.success) {
                  toast.success("Labels Printed");
               }
            })
            .catch(api.catchHandler);
      }
   }

   function voidShipment() {
      let payload = {
         OrderNumber: orderNumber,
         Password: voidPassword
      };
      api.post(`Shipment/VoidShipment`, payload)
         .then(response => {
            if (response && response.data && response.data.success) {
               if (response.data.message?.voidShipmentResponse?.summaryResult?.status?.code === "1"
                  || response.data.message?.voidShipmentResponse?.summaryResult?.status?.code === "&#xD;&#xD;&#xD;1") {
                  toast.success("Successfully voided shipment");
               }
               else {
                  toast.error(response.data.message?.voidShipmentResponse?.summaryResult?.status?.description || "Error voiding the pacakge label");
               }
            }
            else {
               toast.error(response.data.message);
            }
         })
         .catch(api.catchHandler);
   }

   //function shipmentTest() {
   //  if (!printPDF && !selectedPrinter) {
   //    toast.warning("Please select a printer")
   //    return;
   //  }
   //  let payload = {
   //    PrintPDF: printPDF,
   //    OrderNumber: orderNumber,
   //    PrinterId: printPDF ? 0 : selectedPrinter.value,
   //    PrinterName: printPDF ? "" : selectedPrinter.label,
   //    ShippingMethod: 1,
   //    AdditionalBoxes: [
   //      {
   //        OrderNumber: orderNumber,
   //        PackageWeight: 20
   //      },
   //      {
   //        OrderNumber: orderNumber,
   //        PackageWeight: 15
   //      },
   //      {
   //        OrderNumber: orderNumber,
   //        PackageWeight: 42
   //      }
   //    ]
   //  };
   //  if (payload.PrintPDF) {
   //    api
   //      .postDownloadBinary(
   //        `Shipment/CreateUPSShipment`,
   //        payload,
   //        constants.MIME_TYPES.pdf,
   //        `PrintedUPSLabels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
   //        "There was an error downloading the labels, contact your admin."
   //      )
   //      .then((res) => {
   //        if (res?.data === false) {
   //          toast.error(res.message);
   //        } else {
   //          toast.success("Labels Printed");
   //        }
   //      })
   //      .catch((error) => {
   //        api.catchHandler(error);
   //      });
   //  }
   //  else {
   //    api.post("Shipment/CreateUPSShipment", payload)
   //      .then(response => {
   //        if (response.data.success) {
   //        }
   //      })
   //      .catch(api.catchHandler);
   //  }
   //}

   return (
      <DesktopContainer screenName={"UPS Shipment Lookup"}>
         <div className="filter-header mb-3">
            <Row className="justify-content-center">
               <ColPrompt title={"Sales Order #:"} alignPRP="right" />
               <ColValue size={3}>
                  <Input
                     type="text"
                     value={orderNumber}
                     onChange={(e) => {
                        setOrderNumber(e.target.value);
                     }}
                     className="float-start form-control"
                  />
               </ColValue>
               <ColValue size={3}>
                  <Button
                     className={"shredButton"}
                     children={"View UPS Info"}
                     onClick={getShipment}
                  />
               </ColValue>
            </Row>
            <Row>
               <ColPrompt title={""} />
            </Row>
            <Row>
               <ColPrompt title={""} />
            </Row>
         </div>
         {shipmentList && shipmentList.length
            ? <Fragment>
               {_.map(shipmentList, (shipmentDetails, shipIdx) => {
                  let shipment = shipmentDetails;
                  return (shipment
                     ? (<Fragment key={`shipment-${shipIdx}`}>
                        {_.map(shipment.packages, (shipPackage, pkgIdx) => {
                           let name = shipPackage?.name;
                           let shippingCharges = shipPackage?.paymentAmount;
                           let lastActivity = _.find(shipPackage.activities, act => act.statusCode === "D")
                              || _.chain(shipPackage.activities).orderBy(['activityDate'], ['desc']).head().value();
                           let packageInfo = {
                              attentionName: shipPackage?.attentionName,
                              createdAt: shipPackage?.createdAt.replace("T", " ").slice(0, 16),
                              phone: shipPackage?.phone,
                              faxNumber: shipPackage?.faxNumber,
                              addressLine1: shipPackage?.addressLine1,
                              addressLine2: shipPackage?.addressLine2,
                              addressLine3: shipPackage?.addressLine3,
                              city: shipPackage?.city,
                              state: shipPackage?.stateProvince,
                              postalCode: shipPackage?.postalCode,
                           }
                           return printShippingActivity(packageInfo, lastActivity, name, shippingCharges, shipPackage.trackingNumber, shipment.upsShipmentId, pkgIdx);
                           // return lastActivity
                           // ? printShippingActivity(lastActivity, name, shippingCharges, shipPackage.trackingNumber, pkgIdx)
                           // : null;
                        })}
                        {/* <div>
                      <Row className="mt-3">
                        <Col xs="4" style={{ textAlign: "left", marginRight: "5px" }}>
                          Reprint Shipment Labels
                        </Col>
                      </Row>
                    </div> */}
                     </Fragment>)
                     : null
                  )
               })}
               <Row className="mt-3">
                  <Col xs="2" style={{ textAlign: "left", marginRight: "5px" }}>
                     Print To PDF:
                  </Col>
                  <Col>
                     <Switch
                        onChange={() => setPrintPDF(!printPDF)}
                        checked={printPDF}
                        className="react-switch"
                     />
                  </Col>
               </Row>
               {printPDF
                  ? null
                  : (<Row className="mt-3">
                     <Col xs="2" style={{ textAlign: "left", marginRight: "5px" }}>
                        Printers:
                     </Col>
                     <Col xs="4">
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={printers}
                           value={selectedPrinter}
                           onChange={(e) => setSelectedPrinter(e)}
                           isMulti={false}
                           isClearable={true}
                           disabled={printPDF}
                        />
                     </Col>
                     {/* <Col xs="4">
                  <Button className="shredButton" style={{ margin: "5px" }} onClick={()=>{}} >Print</Button>
                  </Col> */}
                  </Row>)}
               <Row className="mt-3">
                  <Col xs="4" style={{ textAlign: "left", marginRight: "5px" }}>
                     Void Shipment
                  </Col>
               </Row>
               <Row className="mt-3">
                  <Col xs="2" style={{ textAlign: "left", marginRight: "5px" }}>
                     Password:
                  </Col>
                  <Col xs="4">
                     <Input
                        type="password"
                        value={voidPassword}
                        onChange={(e) => {
                           setVoidPassword(e.target.value);
                        }}
                        className="float-start form-control"
                     />
                  </Col>
                  <Col xs="4">
                     <Button className="shredButtonGrey" style={{ margin: "5px" }} onClick={voidShipment} >Void Shipment</Button>
                  </Col>
               </Row>
               {/* For testing shipment creation */}
               {/* <Row>
              <ColValue>
                <Button className="shredButton" style={{ margin: "5px" }} onClick={() => shipmentTest()} >create shipment test!</Button>
              </ColValue>
            </Row> */}
            </Fragment>
            : null
         }

      </DesktopContainer>
   );
}
